import { TextMetrics, TextStyle } from 'pixi.js'

export const measureTextHeight = (text: string, style: TextStyle): number =>
  TextMetrics.measureText(text, style).height
